module.exports = __webpack_public_path__ + "static/img/m_name.57abcd7.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/yjyx/m_name.png
// module id = 3sJc
// module chunks = 7